import { api } from '@/lib/api-client';

export interface GithubBackupState {
  enabled: boolean;
  owner: string;
  repo: string;
  branch: string;
  hasToken: boolean;
  updatedAt: string | null;
}

export interface PendingItem {
  file: string;
  attempts: number;
  lastError: string | null;
  nextRetry: string | null;
}

export interface GithubBackupPutBody {
  enabled: boolean;
  owner: string;
  repo: string;
  branch: string;
  token?: string;
}

export interface GithubTestResult {
  ok: boolean;
  sha?: string;
  error?: string;
}

export interface PendingResponse {
  items: PendingItem[];
}

export function get(): Promise<GithubBackupState> {
  return api.get<GithubBackupState>('/admin/github-backup');
}

export function put(body: GithubBackupPutBody): Promise<void> {
  return api.put<void>('/admin/github-backup', body);
}

export function test(): Promise<GithubTestResult> {
  return api.post<GithubTestResult>('/admin/github-backup/test');
}

export function pending(): Promise<PendingResponse> {
  return api.get<PendingResponse>('/admin/github-backup/pending');
}
